var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccompCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 4.1998C16.6748 4.1998 17.1388 4.34055 17.5335 4.60425C17.9281 4.86795 18.2357 5.24276 18.4174 5.68128C18.599 6.1198 18.6465 6.60233 18.5539 7.06786C18.4613 7.53339 18.2328 7.961 17.8971 8.29663C17.5615 8.63226 17.1339 8.86082 16.6684 8.95342C16.2028 9.04602 15.7203 8.9985 15.2818 8.81686C14.8433 8.63522 14.4684 8.32762 14.2047 7.93296C13.941 7.53831 13.8003 7.07432 13.8003 6.59967C13.8002 6.2845 13.8623 5.9724 13.9829 5.68121C14.1034 5.39002 14.2802 5.12544 14.5031 4.90258C14.7259 4.67972 14.9905 4.50295 15.2817 4.38237C15.5729 4.26178 15.885 4.19974 16.2002 4.1998V4.1998Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 9.79993C17.2609 9.79993 18.2783 10.2214 19.0285 10.9716C19.7787 11.7217 20.2001 12.7392 20.2001 13.8001",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59985 5.0002V2.59991C2.60008 2.17566 2.76871 1.76884 3.0687 1.46885C3.3687 1.16885 3.77551 1.00022 4.19977 1H23.4C23.8242 1.00022 24.231 1.16885 24.531 1.46885C24.831 1.76884 24.9997 2.17566 24.9999 2.59991V15.4C24.9997 15.8243 24.831 16.2311 24.531 16.5311C24.231 16.8311 23.8242 16.9997 23.4 17H16.9999",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6003 16.9999V20.1998",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.2002H21.0002",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24.9999C1 24.0544 1.18623 23.1181 1.54807 22.2446C1.9099 21.371 2.44025 20.5773 3.10884 19.9087C3.77742 19.2401 4.57115 18.7098 5.44469 18.3479C6.31824 17.9861 7.2545 17.7999 8.20002 17.7999C9.14554 17.7999 10.0818 17.9861 10.9554 18.3479C11.8289 18.7098 12.6226 19.2401 13.2912 19.9087C13.9598 20.5773 14.4901 21.371 14.852 22.2446C15.2138 23.1181 15.4 24.0544 15.4 24.9999",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80218 11.9218V12.9884C3.84384 14.2165 3.525 15.4298 2.88501 16.4788",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5991 11.9218V12.9884C12.5571 14.2164 12.8757 15.4298 13.5155 16.4788",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81396 12.1508C4.64716 12.145 5.4695 11.9613 6.22594 11.612C6.98238 11.2626 7.65546 10.7557 8.20012 10.1252C8.74475 10.7558 9.41781 11.2628 10.1742 11.6123C10.9307 11.9618 11.753 12.1457 12.5863 12.1517",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20002 7.40002C9.07025 7.40002 9.92094 7.65808 10.6445 8.14155C11.3681 8.62503 11.932 9.31221 12.2651 10.1162C12.5981 10.9202 12.6852 11.8049 12.5154 12.6584C12.3457 13.5119 11.9266 14.2959 11.3113 14.9112C10.6959 15.5266 9.91192 15.9456 9.05841 16.1154C8.2049 16.2852 7.32021 16.1981 6.51622 15.865C5.71223 15.532 5.02505 14.9681 4.54158 14.2445C4.0581 13.5209 3.80005 12.6702 3.80005 11.8C3.80016 10.6331 4.26376 9.514 5.08889 8.68887C5.91402 7.86374 7.03311 7.40014 8.20002 7.40002V7.40002Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccompCom);
export default __webpack_public_path__ + "static/media/accomp_com.cd83f5109f8a58c16600dbcab589235b.svg";
export { ForwardRef as ReactComponent };